import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";
import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";
import { Home } from "@App/Pages/Partner/OctopusEV/Home";
import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";

export function OctopusEV() {
  const { config } = useOrganizationConfig();

  return (
    <DefaultRoutes
      layout={
        <DefaultPartnerLayout
          logos={config.navbar.logos}
          backToPartnerButton={config.navbar.backToPartnerButton}
        />
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
